export const PLAN_LIFE_TIME_FREE = "Life Time Free";
export const PLAN_TRIAL = "Trial";

export const isLifeTimeFreePlan = (planName: string | null | undefined): boolean => {
  return planName === PLAN_LIFE_TIME_FREE;
};

export const isFreePlan = (planName: string | null | undefined): boolean => {
  if (!planName) {
    return false;
  }
  return planName === PLAN_LIFE_TIME_FREE || planName === PLAN_TRIAL;
};

export const isPaidPlan = (planName: string | null | undefined): boolean => {
  if (!planName) {
    return false;
  }
  return !isFreePlan(planName);
};

/** True when catalog marks the descriptor muted for Life Time Free (ltf_exclude = Yes). */
export const isLtfExcludedDescriptor = (
  descriptor: { ltfExclude?: string | null }
): boolean => {
  return (descriptor.ltfExclude ?? "").trim().toLowerCase() === "yes";
};

export const lifeTimeFreeExcludedDescriptorIdsFromCatalog = <
  T extends { id: number; ltfExclude?: string | null }
>(
  descriptorsByCategory: Record<string, T[]>
): number[] => {
  return Object.values(descriptorsByCategory).flatMap((categoryDescriptors) =>
    categoryDescriptors.filter(isLtfExcludedDescriptor).map((descriptor) => descriptor.id)
  );
};
